export { Dashboard as default } from './Dashboard';
export type { DashboardProps } from './Dashboard';

export { useTravelBookingDialogState } from './components/DashboardContentV2/hooks/useTravelBookingDialogState';
export { BookingDialog } from './components/DashboardContentV2/BookingDialog/BookingDialog';
export { enrichDashboardTelemetryExtraInfo, DashboardTelemetryProvider } from './Dashboard.telemetry';
